import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  fetchMedProsNeedingEmail,
  downloadCsv,
  MedProsNeedingEmailResponse,
  MedProsNeedingEmailRow,
} from '~/services/predefinedReports';
import { PredefinedResultsLayout, Column } from './PredefinedResultsLayout';

const columns: Column<MedProsNeedingEmailRow>[] = [
  { key: 'med_pro', label: 'Medical Professional' },
  { key: 'status', label: 'Campaign Status' },
  { key: 'patient_last_name', label: 'Patient last name' },
  { key: 'patient_first_name', label: 'First name' },
  { key: 'patient_middle_name', label: 'Middle name' },
];

const MedProsNeedingEmailResults: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState<MedProsNeedingEmailResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = { campaign_status: searchParams.get('campaign_status') || undefined };
    setLoading(true);
    fetchMedProsNeedingEmail(params)
      .then((d) => { setData(d); setError(null); })
      .catch((e) => { setError(e.message); setData(null); })
      .finally(() => setLoading(false));
  }, [searchParams]);

  const subtitle = data?.campaign_status
    ? `Filtered to status: ${data.campaign_status}`
    : 'All statuses';

  return (
    <PredefinedResultsLayout
      title='Medical Professionals Needing Email'
      subtitle={subtitle}
      columns={columns}
      rows={data?.rows ?? []}
      loading={loading}
      error={error}
      rowKey={(r) => r.campaign_id}
      onDownloadCsv={() => downloadCsv('med-pros-needing-email', searchParams)}
    />
  );
};

export default MedProsNeedingEmailResults;
